import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { PayloadService } from '../payload/payload.service';
import { tap, switchMap } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class DidService {

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }

    add(id, redirect, redirect_id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "did/add", {
                        "payload": payload,
                        "id" : id,
                        "redirect": redirect,
                        "redirect_id": redirect_id
                    });
                }
            )
        )
    }

    get(id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "did/get", {
                        "payload": payload,
                        "id": id
                    });
                }
            )
        )
    }

    edit(id, redirect, redirect_id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "did/edit", {
                        "payload": payload,
                        "id" : id,
                        "redirect": redirect,
                        "redirect_id": redirect_id
                    });
                }
            )
        )
    }

    delete(id): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "did/delete", {
                        "payload": payload,
                        "id" : id
                    });
                }
            )
        )
    }

    list(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "did/list", {
                        "payload": payload
                    });
                }
            )
        )
    }

    stock(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "did/stock", {
                        "payload": payload
                    });
                }
            )
        )
    }
}
